import React, {HTMLInputTypeAttribute} from 'react';
import classNames from "classnames";


import './Input.css';


export interface SelectProps {
    value: string | number;
    min?: number;
    maxLength?: number;
    onChange?: (newValue: string) => void;
    onBlur?: () => void;
    disabled?: boolean;
    type?: HTMLInputTypeAttribute;
    placeholder?: string;
    className?: string;
    hasError?: boolean;
}


export const Input = (
    {
        value,
        onChange,
        onBlur,
        disabled,
        type,
        min,
        maxLength,
        placeholder,
        className,
        hasError,
    }: SelectProps
) => {
    return (
        <input className={
            classNames({
                "Input body-large": true,
                "Input--disabled": disabled,
                "Input--error": hasError,
                [className!]: className,
            })
        }
               onChange={(event) => {
                   onChange && onChange(event.target.value);
               }}
               onBlur={onBlur}
               disabled={disabled}
               value={value}
               type={type}
               min={min}
               maxLength={maxLength}
               placeholder={placeholder}
        />
    )
}
